import { cards } from '@/mocks/homeMocks';

export default function CardsSection() {
  return (
    <section id="cards" className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2 scroll-mt-20">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-600 mb-6">
            编辑团队为你精心挑选的高质量漫画作品
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
            {cards.map((item) => (
              <a
                key={item.id}
                href="#cards"
                className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-300 transition-all"
              >
                <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-200">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2 py-0.5 bg-accent-500 text-white text-xs rounded whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <div className="absolute bottom-3 right-3">
                    <span className="flex items-center gap-1 px-2 py-0.5 bg-foreground-950/70 text-background-50 text-xs rounded whitespace-nowrap">
                      <i className="ri-fire-line text-xs"></i> {item.heat}
                    </span>
                  </div>
                </div>
                <div className="p-3 md:p-4">
                  <h3 className="text-sm md:text-base text-foreground-950 mb-1 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-600 line-clamp-2">
                    {item.description}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}